import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { HatcheriesAdapter } from './dto/hatcheries.adapter';
import { HatcheriesController } from './hatcheries.controller';
import { Hatcheries } from './hatcheries.entity';
import { HatcheriesService } from './hatcheries.service';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([Hatcheries]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [HatcheriesController],
  providers: [HatcheriesService,HatcheriesController,ApplicationExceptionHandler, HatcheriesAdapter,LogsService],
  exports: [HatcheriesService],
})
export class HatcheriesModule {}
